import { render, staticRenderFns } from "./tab_educacion_informal.vue?vue&type=template&id=90cfa41c&scoped=true"
import script from "./tab_educacion_informal.vue?vue&type=script&lang=js"
export * from "./tab_educacion_informal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cfa41c",
  null
  
)

export default component.exports